export default __webpack_public_path__ + "static/media/vernon-home.558e7ad2.jpg";